<script setup lang="ts">
import { computed } from 'vue'

import Button from '@shared/fondof-ui/components/atoms/button/Button.vue'
import { spaceCaseVariantToCamelCaseVariant } from '@storefront-satch/components/atoms/button/mapper'
import type { ButtonProps } from '@storefront-satch/components/atoms/button/types'
import { buttonVariants } from '@storefront-satch/components/atoms/button/variants'

const props = withDefaults(defineProps<ButtonProps>(), {
  variant: 'primary',
  size: 'default',
  textSize: 'base',
  padding: 'base',
  as: 'button',
})

const variant = computed(() => {
  return spaceCaseVariantToCamelCaseVariant(props.variant)
})
</script>

<template>
  <Button
    :class="[
      buttonVariants({
        variant,
        size: props.size,
        textSize: props.textSize,
        padding: props.padding,
        rounded: props.rounded,
      }),
      props.class ?? '',
    ]"
    :as="props.as"
    :as-child="props.asChild"
    :data-slot="props.size === 'icon' ? 'icon' : 'button'"
    :href="props.href"
    :disabled="props.disabled"
  >
    <slot />
  </Button>
</template>
